// The name of the user's view (WEB-7113, API-3644): metadata.View on each reply, and
// GET api/v2/Query/View before the first question. { State, StateName, County, Units[] }, each
// unit { Name, LayerId, Code, Species, ValidGeo } for one species' unit layer at the view's center.
// The GET currently answers in camelCase, so both are read.

const get = (obj, name) => {
  if (!obj || typeof obj !== 'object') return undefined
  if (name in obj) return obj[name]
  const key = Object.keys(obj).find(k => k.toLowerCase() === name.toLowerCase())
  return key === undefined ? undefined : obj[key]
}

// A View in one shape, or null when it names nothing.
export const normalizeView = view => {
  if (!view || typeof view !== 'object') return null
  const units = (get(view, 'Units') || []).filter(u => u && typeof u === 'object').map(u => ({
    name: get(u, 'Name') || null,
    code: get(u, 'Code') != null ? String(get(u, 'Code')) : null,
    species: get(u, 'Species') || null
  }))
  const state = get(view, 'State') || null
  const county = get(view, 'County') || null
  if (!state && !county && units.length === 0) return null
  return { state, stateName: get(view, 'StateName') || null, county, units }
}

// "GMU 4", or "GMU 4 and 2 more units" when the species' layers disagree. Null without units.
export const unitLabel = view => {
  if (!view || view.units.length === 0) return null
  const names = [...new Set(view.units.map(u => u.name || (u.code ? `Unit ${u.code}` : null)).filter(Boolean))]
  if (names.length === 0) return null
  return names.length === 1 ? names[0] : `${names[0]} and ${names.length - 1} more ${names.length === 2 ? 'unit' : 'units'}`
}

// "Routt County, GMU 4" for the welcome heading; null when there's nothing to say.
export const viewLabel = view => {
  if (!view) return null
  const place = view.county || view.stateName || view.state
  return [place, unitLabel(view)].filter(Boolean).join(', ') || null
}

// "Routt County, CO · GMU 4" for the "What Artemis can see" popover.
export const viewAreaRow = view => {
  if (!view) return null
  const place = [view.county, view.state].filter(Boolean).join(', ') || view.stateName
  return [place, unitLabel(view)].filter(Boolean).join(' · ') || null
}

// The one unit name to put in a starter question, when every species agrees on it.
export const singleUnitName = view => {
  const label = unitLabel(view)
  return label && !/ more units?$/.test(label) ? label : null
}
